import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    overallSummaryTitle: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(3),
        fontSize: "24px !important",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        textAlign: "start",
    },
    graphContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        position: "relative",
        padding: `${theme.spacing(5)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
    },
    graphGridItemContainer: {
        height: "35vh !important",
        "@media (min-width: 1300px)": {
            height: "45vh !important",
        },
    },
}));
